import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import {
  Container,
  Segment,
  Dimmer,
  Loader,
  Table,
  Button,
  Pagination,
  Modal,
} from 'semantic-ui-react';
import PropTypes from 'prop-types';
import {
  activateFeatureSubscriptionsOutletAction,
  getFeatureSubscriptionsAction,
} from 'state/business/actions';
import { SemanticToastContainer } from 'react-semantic-toasts';

const mapStateToPropsFeatureSubscriptions = ({ business }) => ({
  featureSubscriptions: business.featureSubscriptions,
  loadingOutlets: business.loadingOutlets,
  allBusiness: business.allBusiness,
});

const FeatureSubscriptions = connect(mapStateToPropsFeatureSubscriptions)(
  props => {
    const [modal, setModal] = useState({
      selectedFeature: null,
      listOutlet: {
        isOpen: false,
      },
      activateFeat: {
        isOpen: false,
      },
    });
    const {
      dispatch,
      allBusiness,
      featureSubscriptions,
      loadingOutlets,
    } = props;
    let paging = null;
    if (featureSubscriptions) {
      paging = featureSubscriptions.paging;
    }
    let totalPages = 0;
    if (paging) totalPages = Math.ceil(paging.total / paging.size);

    useEffect(() => {
      const currBusinessId = allBusiness.data[allBusiness.activeIndex].id;
      const payload = {
        page: 1,
        size: 10,
        businessId: currBusinessId,
      };
      dispatch(getFeatureSubscriptionsAction(payload));
    }, [allBusiness.activeIndex, allBusiness.data, dispatch]);

    const handleOnPageChange = (_, val) => {
      const currBusinessId = allBusiness.data[allBusiness.activeIndex].id;
      const { activePage } = val;
      const payload = {
        page: activePage,
        size: 10,
        businessId: currBusinessId,
      };
      dispatch(getFeatureSubscriptionsAction(payload));
    };

    const handleActivateFeature = () => {
      const currBusinessId = allBusiness.data[allBusiness.activeIndex].id;
      setModal({
        ...modal,
        selectedFeature: null,
        activateFeat: { ...modal.activateFeat, isOpen: false },
      });
      const payload = {
        businessId: currBusinessId,
        active: true,
        feature_name: modal.selectedFeature.name,
      };
      dispatch(activateFeatureSubscriptionsOutletAction(payload));
    };

    const handleOpenActivateFeatModal = feature => {
      setModal({
        ...modal,
        selectedFeature: feature,
        activateFeat: { ...modal.activateFeat, isOpen: true },
      });
    };

    const handleCloseActivateFeatModal = () => {
      setModal({
        ...modal,
        selectedFeature: null,
        activateFeat: { ...modal.activateFeat, isOpen: false },
      });
    };

    const handleOpenListOutletModal = feature => {
      setModal({
        ...modal,
        selectedFeature: feature,
        listOutlet: { ...modal.listOutlet, isOpen: true },
      });
    };
    const handleCloseListOutletModal = () => {
      setModal({
        ...modal,
        selectedFeature: null,
        listOutlet: { ...modal.listOutlet, isOpen: false },
      });
    };

    return (
      <Container
        style={{ overflowY: 'scroll', maxHeight: '50vh', padding: '1vh' }}
      >
        <SemanticToastContainer />
        {/* list outlet modal  */}
        <Modal size="small" open={modal.listOutlet.isOpen}>
          <Modal.Header style={{ background: '#337ab7', color: 'white' }}>
            <strong>List Outlet</strong>
          </Modal.Header>
          <Modal.Content>
            <Container
              style={{
                overflowY: 'scroll',
                maxHeight: '50vh',
                paddingRight: '1vh',
              }}
            >
              <Segment style={{ padding: '0px' }}>
                <Table celled selectable style={{ margin: '0px' }}>
                  <Table.Header style={{ position: 'sticky', top: '0px' }}>
                    <Table.Row>
                      <Table.HeaderCell>Name</Table.HeaderCell>
                      <Table.HeaderCell>Start Date</Table.HeaderCell>
                      <Table.HeaderCell>Expiration Date</Table.HeaderCell>
                    </Table.Row>
                  </Table.Header>
                  <Table.Body>
                    {modal.selectedFeature ? (
                      modal.selectedFeature.outlets.map(outlet => {
                        let keys = '';
                        Object.keys(outlet).forEach(key => {
                          keys += outlet[key];
                        });
                        const convertDate = payloadDate => {
                          const dateTimeFormat = new Intl.DateTimeFormat('id', {
                            year: 'numeric',
                            month: 'long',
                            day: 'numeric',
                          });
                          const date = new Date(payloadDate);
                          return dateTimeFormat.format(date);
                        };

                        return (
                          <Table.Row key={keys}>
                            <Table.Cell key={`${keys}name`}>
                              {outlet.name}
                            </Table.Cell>
                            <Table.Cell key={`${keys}start-date`}>
                              {!outlet.start_date
                                ? '-'
                                : convertDate(outlet.start_date)}
                            </Table.Cell>
                            <Table.Cell key={`${keys}expiration-date`}>
                              {!outlet.expiration_date
                                ? '-'
                                : convertDate(outlet.expiration_date)}
                            </Table.Cell>
                          </Table.Row>
                        );
                      })
                    ) : (
                      <></>
                    )}
                  </Table.Body>
                </Table>
              </Segment>
            </Container>
          </Modal.Content>
          <Modal.Actions>
            <Button
              style={{ color: '#333' }}
              onClick={handleCloseListOutletModal}
            >
              Close
            </Button>
          </Modal.Actions>
        </Modal>
        {/* activate feature modal  */}
        <Modal size="small" open={modal.activateFeat.isOpen}>
          <Modal.Header style={{ background: '#d9534f', color: 'white' }}>
            <strong>Confirm</strong>
          </Modal.Header>
          <Modal.Content>
            <p>
              Are you sure you want to activate{' '}
              <strong>
                {modal.selectedFeature ? modal.selectedFeature.name : ''}{' '}
              </strong>
              ?
            </p>
          </Modal.Content>
          <Modal.Actions>
            <Button
              style={{ color: '#333' }}
              onClick={handleCloseActivateFeatModal}
            >
              Cancel
            </Button>
            <Button
              style={{ background: '#d9534f', color: 'white' }}
              onClick={handleActivateFeature}
            >
              Update
            </Button>
          </Modal.Actions>
        </Modal>
        <h3>Feature LIST</h3>
        <Segment style={{ padding: '0px' }}>
          <Dimmer active={loadingOutlets}>
            <Loader size="massive">Loading</Loader>
          </Dimmer>
          <Table celled selectable style={{ margin: '0px' }}>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell>Nama</Table.HeaderCell>
                <Table.HeaderCell>Status</Table.HeaderCell>
                <Table.HeaderCell>Actions</Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {featureSubscriptions.data ? (
                featureSubscriptions.data.map(feature => {
                  let keys = '';
                  Object.keys(feature).forEach(key => {
                    keys += feature[key];
                  });

                  return (
                    <Table.Row key={keys}>
                      <Table.Cell key={`${keys}name`}>
                        {feature.name}
                      </Table.Cell>
                      <Table.Cell key={`${keys}status`}>
                        {!feature.is_active ? (
                          <p style={{ color: 'red' }}>INACTIVE</p>
                        ) : (
                          <p style={{ color: 'green' }}>ACTIVE</p>
                        )}
                      </Table.Cell>
                      <Table.Cell key={`${keys}action`}>
                        <Button
                          color="blue"
                          onClick={() => handleOpenListOutletModal(feature)}
                        >
                          Outlets
                        </Button>
                        <Button
                          color="green"
                          onClick={() => handleOpenActivateFeatModal(feature)}
                        >
                          Activate
                        </Button>
                      </Table.Cell>
                    </Table.Row>
                  );
                })
              ) : (
                <></>
              )}
            </Table.Body>
            {paging ? (
              <Table.Footer>
                <Table.Row>
                  <Table.HeaderCell colSpan="7">
                    <Pagination
                      activePage={paging.page}
                      totalPages={totalPages}
                      onPageChange={handleOnPageChange}
                      size="mini"
                    />
                  </Table.HeaderCell>
                </Table.Row>
              </Table.Footer>
            ) : (
              <></>
            )}
          </Table>
        </Segment>
      </Container>
    );
  }
);

FeatureSubscriptions.propTypes = {
  dispatch: PropTypes.func.isRequired,
  featureSubscriptions: PropTypes.object.isRequired,
  loadingOutlets: PropTypes.bool.isRequired,
  allBusiness: PropTypes.object.isRequired,
};

export default FeatureSubscriptions;
